<template>
    <div>

        <!-- Header -->
        <div class="pt-3 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-3 d-flex justify-content-between align-items-center mb-3">
                        <h5 class="m-1 p-0 align-self-center">
                             Redações
                        </h5>

                        <div class="d-flex d-sm-none">
                            <!-- Period -->
                            <date-input v-if="typeOfDataFilter=== 'send'" :text="'Data de Envio'"  :start-date="filter.created_at_from" :end-date="filter.created_at_to" locale="pt-BR" @changeDate="changeCreateAt" class=""></date-input>
                            <span role="button" class="bg-white btn btn-light" v-if="filter.created_at_from && filter.created_at_to" @click="clearCreateAt">
                                <i class="fas fa-times"></i>
                            </span>
                            <date-input v-if="typeOfDataFilter=== 'correction'" :text="'Data de Correção'"  :start-date="filter.finished_correction_from" :end-date="filter.finished_correction_to" locale="pt-BR" @changeDate="changeFinishedCorrection" class=""></date-input>
                            <span role="button" class="bg-white btn btn-light" v-if="filter.finished_correction_from && filter.finished_correction_to" @click="clearFinishedCorrection">
                                <i class="fas fa-times"></i>
                            </span>
                            <span class="dropdown">
                                <button role="button" class="bg-white btn btn-light" data-bs-toggle="dropdown">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <div class="dropdown-item-text">
                                            <b-form-group class="d-flex flex-column justify-content-start mb-0">
                                                <b-form-radio v-model="typeOfDataFilter" size="sm" value="send" name="date-tipe-filter-sm">por Envio</b-form-radio>
                                                <b-form-radio v-model="typeOfDataFilter" size="sm" value="correction" name="date-tipe-filter-sm">por Correção</b-form-radio>
                                            </b-form-group>
                                        </div>

                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9 text-left gap-2 text-sm-right d-flex justify-content-sm-end justify-content-between align-items-center mb-3">

                        <div class="d-none d-sm-flex">
                            <!-- Period -->
                            
                            <date-input v-if="typeOfDataFilter=== 'send'" :text="'Data de Envio'"  :start-date="filter.created_at_from" :end-date="filter.created_at_to" locale="pt-BR" @changeDate="changeCreateAt" class=""></date-input>
                            <span role="button" class="bg-white btn btn-light" v-if="filter.created_at_from && filter.created_at_to" @click="clearCreateAt">
                                <i class="fas fa-times"></i>
                            </span>
                            <date-input v-if="typeOfDataFilter=== 'correction'" :text="'Data de Correção'"  :start-date="filter.finished_correction_from" :end-date="filter.finished_correction_to" locale="pt-BR" @changeDate="changeFinishedCorrection" class=""></date-input>
                            <span role="button" class="bg-white btn btn-light" v-if="filter.finished_correction_from && filter.finished_correction_to" @click="clearFinishedCorrection">
                                <i class="fas fa-times"></i>
                            </span>
                            <span class="dropdown">
                                <button role="button" class="bg-white btn btn-light" data-bs-toggle="dropdown">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <div class="dropdown-item-text">
                                            <b-form-group class="d-flex flex-column justify-content-start mb-0">
                                                <b-form-radio v-model="typeOfDataFilter" size="sm" value="send" name="date-tipe-filter">por Envio</b-form-radio>
                                                <b-form-radio v-model="typeOfDataFilter" size="sm" value="correction" name="date-tipe-filter">por Correção</b-form-radio>
                                            </b-form-group>
                                        </div>

                                    </li>
                                </ul>
                            </span>
                        </div>
                        <div class="dropdown">

                            <button id="filter-drop" class="btn btn-primary d-flex align-items-center gap-2 rounded-0" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z" />
                                </svg>

                                <div>Filtrar</div>
                            </button>

                            <ul class="dropdown-menu dropdown-menu-end" style="min-with: 200px ; width: 350px; max-width: 450px;">
                                <li>
                                    <div class="dropdown-item-text fw-semibold px-2 d-flex justify-content-between">
                                        Filtros
                                        <span role="button" class="btn btn-sm btn-primary" @click="clearFilters">
                                            Limpar
                                        </span>
                                    </div>
                                </li>
                                <li><hr class="dropdown-divider"></li>
                                
                                <li>
                                    <span class="dropdown-header px-2 py-0" >TEMA</span>
                                    <div class="dropdown-item-text px-1 mb-2 mx-2">
                                        <multiselect
                                            v-model="theme"
                                            :options="themes"
                                            :loading="loadingTheme"
                                            track-by="id"
                                            label="title"
                                            placeholder="Filtrar por Tema"
                                            @select="selectTheme"
                                            @remove="removeTheme"
                                            @search-change="searchTheme"
                                            tag-placeholder="Filtrar por Tema"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">

                                                <span slot="noResult">
                                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                                </span>

                                                <span slot="noOptions">
                                                    Não há atividades disponíveis para exibir :(
                                                </span>

                                        </multiselect>
                                    </div>

                                </li>
                                <li>
                                    <span class="dropdown-header px-2 py-0" >ATIVIDADE</span>
                                    <div class="dropdown-item-text px-1 mb-2 mx-2">
                                        <multiselect
                                            v-model="task"
                                            :options="tasks"
                                            :loading="loadingTask"
                                            track-by="id"
                                            label="name"
                                            placeholder="Filtrar por Atividade"
                                            @select="selectTask"
                                            @remove="removeTask"
                                            @search-change="searchTask"
                                            tag-placeholder="Filtrar por Atividade"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">

                                                <span slot="noResult">
                                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                                </span>

                                                <span slot="noOptions">
                                                    Não há atividades disponíveis para exibir :(
                                                </span>

                                        </multiselect>
                                    </div>

                                </li>

                                <li v-if="canFilterCorrection">
                                    <span class="dropdown-header px-2 py-0" >CORRETOR</span>
                                    <div class="dropdown-item-text px-1 mb-2 mx-2">
                                        <multiselect
                                            v-model="teacher2"
                                            :options="teachersWithNull"
                                            :loading="loadingTeacher"
                                            track-by="id"
                                            label="name"
                                            placeholder="Filtrar por Corretor"
                                            @select="selectTeacher"
                                            @remove="removeTeacher"
                                            tag-placeholder="Filtrar por Corretor"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">

                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>

                                            <span slot="noOptions">
                                                Não há corretores disponíveis para exibir :(
                                            </span>

                                        </multiselect>
                                    </div>

                                </li>

                                <li>
                                    <span class="dropdown-header px-2 py-0" >MODO DE CORREÇÃO</span>
                                    <div class="dropdown-item-text px-1 mb-2 mx-2">
                                        <multiselect
                                            v-model="mode"
                                            :options="modesOnlyActives"
                                            :loading="loading"
                                            track-by="id"
                                            label="name"
                                            placeholder="Filtrar Modo de Correção"
                                            @select="selectMode"
                                            @remove="removeMode"
                                            tag-placeholder="Filtrar Modo de Correção"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">
                                                <span slot="noResult">
                                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                                </span>

                                                <span slot="noOptions">
                                                    Não há modos de correção para exibir :(
                                                </span>
                                        </multiselect>
                                    </div>


                                </li>

                            </ul>
                        </div>
                        <!-- Create -->
                        <a :href="endpointCreate" class="btn btn-outline-primary rounded-0  d-flex align-items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                            </svg>

                            <div>
                                Enviar Redação
                            </div>
                        </a>


                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-4 mb-3">

                    <multiselect
                        v-model="group"
                        :options="groups"
                        :loading="loadingGroup"
                        track-by="id"
                        label="name"
                        placeholder="Filtrar Turma"
                        @select="selectGroup"
                        @remove="removeGroup"
                        @search-change="searchGroup"
                        tag-placeholder="Filtrar Turma"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                        <span slot="noResult">
                            Ops! Nenhum resultado encontrado na pesquisa :(
                        </span>

                        <span slot="noOptions">
                            Não há turmas disponíveis para exibir :(
                        </span>

                    </multiselect>
                </div>
                <div class="col-12 col-sm-4 mb-3">

                    <multiselect
                        v-model="student"
                        :options="students"
                        :loading="loadingStudent"
                        track-by="id"
                        label="name"
                        placeholder="Filtrar Aluno"
                        @select="selectStudent"
                        @remove="removeStudent"
                        @search-change="searchStudent"
                        tag-placeholder="Filtrar Aluno"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há alunos disponíveis para exibir :(
                            </span>

                    </multiselect>
                </div>
                <div class="col-12 col-sm-4 mb-3">

                    <multiselect
                        v-model="status"
                        :options="statusOptions"
                        :loading="loading"
                        track-by="id"
                        label="name"
                        placeholder="Filtrar Status"
                        @select="selectStatus"
                        @remove="removeStatus"
                        tag-placeholder="Filtrar Status"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                        <span slot="noOptions">
                                Não há status para exibir :(
                            </span>

                    </multiselect>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="d-flex gap-1 " >
                <div @click="removeGroup" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.group_id">
                    {{ group.name }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeTheme" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.theme_id">
                    {{ theme.title }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeStudent" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.student_id">
                    {{ student.name }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeStatus" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.status">
                    {{ status.name }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeMode" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.mode_id">
                    {{ mode.name }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeTask" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.task_id">
                    {{ task.name }}
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

                <div @click="removeTeacher" role="button" class="btn btn-sm btn-outline-primary rounded-pill px-2 py-1 d-flex gap-1 align-items-center mb-3" v-if="filter.teacher_id">
                    {{ teacher2.name }}

                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                    </div>
                </div>

            </div>
            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
                <div class="col mb-3">
                    <div class="card rounded">
                        <div class="card-body">
                            <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de redações que ainda não foram corrigidas">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="d-flex gap-3 align-items-center">
                                <div class="rounded-circle p-2 w-auto" style="background-color: #c26e0010;">
                                    <svg style="color: #c26e00;" height="32px" width="32px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                    </svg>
                                </div>
                                <div class="lh-sm ">
                                    <div class="fw-bold fs-5">{{essaysWait}}</div>
                                    <div class="text-black-50 fw-normal">Redações para corrigir</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col mb-3">
                    <div class="card rounded">
                        <div class="card-body">
                            <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de redações corrigidas">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="d-flex gap-3 align-items-center">
                                <div class="rounded-circle p-2 w-auto" style="background-color: #00c28810;">
                                    <svg style="color: #00c288;" height="32px" width="32px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 019 9v.375M10.125 2.25A3.375 3.375 0 0113.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 013.375 3.375M9 15l2.25 2.25L15 12" />
                                      </svg>
                                </div>
                                <div class="lh-sm ">
                                    <div class="fw-bold fs-5">{{essaysOkay}}</div>
                                    <div class="text-black-50 fw-normal">Redações corrigidas</div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="col mb-3">
                    <div class="card rounded">
                        <div class="card-body">
                            <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de correções em andamento">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                </svg>
                            </button>
                            <div class="d-flex gap-3 align-items-center">
                                <div class="rounded-circle p-2 w-auto" style="background-color: #007bc210;">
                                    <svg style="color: #007bc2;" height="32px" width="32px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                    </svg>
                                </div>
                                <div class="lh-sm ">
                                    <div class="fw-bold fs-5">{{essaysInProgress}}</div>
                                    <div class="text-black-50 fw-normal">Redações em correção</div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <b-card class="mb-4">
                <div class="mb-2 fw-bold">Redações dos Alunos</div>
                <!-- Load Table -->
                <b-skeleton-wrapper :loading="loading">

                <!-- Loading -->
                <template #loading>
                    <b-skeleton-table
                        :rows="lastResultsCount"
                        :columns="6"
                        :table-props="{ bordered: true, striped: true }"
                    >
                    </b-skeleton-table>
                </template>

                <div class="alert alert-info d-flex justify-content-between align-items-center" v-if="selected.length > 0">

                    <div>
                        Você está selecionando <b>{{ selected.length }}</b> redações.
                    </div>

                    <div>
                        <b-dropdown size="sm" text="Ações" variant="primary" right>
                            <b-dropdown-item @click="selectTeacherBatch" :disabled="! canChooseCorrection">Selecionar Corretor</b-dropdown-item>
                        </b-dropdown>
                    </div>

                </div>

                <!-- Table -->
                <b-table
                    id="essayTable"
                    :items="table"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @sort-changed="changeSortable"
                    @row-selected="onRowSelected"
                    empty-text="Não encontramos nenhum resultado na busca :("
                    class="bg-white mb-0"
                    stacked="md"
                    ref="selectableTable"
                    select-mode="multi"
                    :selectable="true"
                    :sticky-header="true"
                    show-empty
                    no-local-sorting
                    bordered
                    hover>

                    <template v-slot:head(selected)="data">
                        <b-form-checkbox @input="inputSelectAll($event)"></b-form-checkbox>
                    </template>

                    <template #cell(selected)="{ rowSelected, index}">
                        <b-form-checkbox
                            v-model="rowSelected"
                            @input="inputSelect($event, index)"
                        ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(group.name)="row">
                        <span v-if="row.item.group">
                            <span v-if="row.item.group.name" v-b-tooltip.hover :title="row.item.group.name">
                                {{ row.item.group.name | truncate(10) }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(theme)="row">
                        <span v-if="row.item.theme">
                            <span v-if="row.item.theme.title" v-b-tooltip.hover :title="row.item.theme.title">
                                <a :href="'/teacher/themes/' + row.item.theme.id" target="_blank">
                                    {{ row.item.theme.title | truncate(30) }}
                                </a>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(student.name)="row">
                        <span v-b-tooltip.hover :title="row.item.student.name">
                            {{ row.item.student.name | truncate(10) }}
                        </span>


                    </template>

                    <template v-slot:cell(teacher.name)="row">
                        <span v-if="row.item.teacher">
                            <span>
                                {{ row.item.teacher.name | truncate(15) }}
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>



                    </template>

                    <template v-slot:cell(created_at)="row">
                        <span v-b-tooltip.hover :title="row.item.created_at | moment('from', 'now')">
                            {{ row.item.created_at | moment('DD/MM/YYYY HH:mm') }}
                        </span>
                    </template>

                    <template v-slot:cell(finished_correction)="row">
                        <span v-if="row.item.finished_correction">
                            <span v-b-tooltip.hover :title="row.item.finished_correction | moment('from', 'now')">
                                {{ row.item.finished_correction | moment('DD/MM/YYYY HH:mm') }}
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(status)="row">
                        <span v-if="row.item.status === 'BLOCK'" class="text-warning px-2 py-1 rounded-pill" style="background-color: #ffc10710">
                            Aguardando Devolução
                        </span>

                        <span v-if="row.item.status === 'WAIT'" class="text-danger px-2 py-1 rounded-pill" style="background-color: #dc354510">
                            Aguardando
                        </span>

                        <span v-if="row.item.status === 'IN_PROGRESS'" class="text-info px-2 py-1 rounded-pill text-nowrap" style="background-color: #0dcaf010">
                             Em Andamento
                        </span>

                        <span v-if="row.item.status === 'OKAY'" class="text-success px-2 py-1 rounded-pill" style="background-color: #19875410">
                            Corrigida
                        </span>

                    </template>

                    <template v-slot:cell(note)="row">
                        <span v-if="row.item.status === 'OKAY'">
                            <span v-if="!row.item.no_note">
                                {{ row.item.note }}
                            </span>
                            <span class="px-2 py-1 rounded-pill text-nowrap" style="background-color: #ffc10720; color: #ffc107;" v-else>
                                Sem nota
                            </span>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </template>

                    <template v-slot:cell(mode)="row">
                        <span v-if="row.item.mode">
                            <span v-b-tooltip.hover :title="row.item.mode.name">
                                {{ row.item.mode.name | truncate(25) }}
                            </span>
                        </span>
                        <span v-else>
                            <span v-if="row.item.theme">
                                <span v-b-tooltip.hover :title="row.item.theme.mode.name">
                                    {{ row.item.theme.mode.name | truncate(25) }}
                                </span>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                    </template>

                    <template v-slot:cell(actions)="row">
                        <div class="d-inline-flex gap-2">

                            <div class="text-center text-nowrap drowdown">
                                <button role="button" class="btn btn-sm btn-primary rounded-1" data-bs-toggle="dropdown">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1.5em" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <a class="dropdown-item">
                                            <last-essays  :student-id="row.item.student_id" :modal-id="'modal' + row.item.id" :mode-button="false"><span>Histórico do aluno</span></last-essays>

                                        </a>

                                    </li>
                                    <li>

                                        <!-- Image -->
                                        <a href="javascript:void(1);" class="dropdown-item mr-2" @click="showImage(row.item)" >
                                            <i class="fas fa-camera"></i>
                                            <span>Foto da redação</span>
                                        </a>
                                    </li>
                                    <li>
                                        <!-- Details -->
                                        <a href="javascript:void(1);" class="dropdown-item mr-2" @click="showDetails(row.item)">
                                            <i class="fas fa-info-circle"></i>
                                            <span>Resumo</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class=" text-muted dropdown-item" href="javascript:void(1);" v-if="canChooseCorrection && row.item.status !== 'WAIT'" @click="showTeacherModal(row.item)" >
                                            <i class="fas fa-edit"></i>
                                            <span>Mudar corretor</span>
                                        </a>

                                        <a class=" text-primary dropdown-item" href="javascript:void(1);" v-if="canChooseCorrection && row.item.status === 'WAIT'" @click="showTeacherModal(row.item)">
                                            <i class="fas fa-edit"></i>
                                            <span>Mudar corretor</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="text-primary dropdown-item" href="javascript:void(1);" v-if="row.item.status !== 'OKAY' && selected.length <= 1" @click="showUpdateThemeOrMode(row.item)">
                                            <i class="fas fa-edit"></i>
                                            <span>Mudar Tema/Modo</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="text-primary dropdown-item" href="javascript:void(1);" v-if="row.item.status !== 'OKAY' && selected.length <= 1 && revisorTeacher && row.item.reviews.length === 0" @click="showReviewTeacher(row.item)">
                                            <i class="fas fa-edit"></i>
                                            <span>Professor Revisor</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="text-primary dropdown-item" href="javascript:void(1);" v-if="selected.length <= 1 && revisorTeacher && row.item.reviews.length > 0" @click="showReview(row.item.reviews[0])">
                                            <i class="fas fa-eye"></i>
                                            <span>Revisões</span>
                                        </a>
                                    </li>

                                </ul>





                            </div>
                            <div class="w-auto">
                                <span v-if="row.item.status === 'BLOCK'">
                                    <a :href="row.item.content_type==='TEXT'? '/teacher/essays/' + row.item.id + '/correction/new':'/teacher/essays/' + row.item.id + '/correction'" class="text-warning"  :disabled="loading" target="_blank" v-b-tooltip.hover title="Acessar correção">
                                        <svg  height="16px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>

                                    </a>
                                </span>

                                <span v-if="row.item.status === 'WAIT'">
                                    <a :href="row.item.content_type==='TEXT'? '/teacher/essays/' + row.item.id + '/correction/new':'/teacher/essays/' + row.item.id + '/correction'" class="text-danger"  :disabled="loading" target="_blank" v-b-tooltip.hover title="Acessar correção">
                                        <svg  height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>

                                    </a>
                                </span>

                                <span v-if="row.item.status === 'IN_PROGRESS'">
                                    <a :href="row.item.content_type==='TEXT'? '/teacher/essays/' + row.item.id + '/correction/new':'/teacher/essays/' + row.item.id + '/correction'" class="text-info"  :disabled="loading" target="_blank" v-b-tooltip.hover title="Acessar correção">
                                        <svg  height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>

                                    </a>
                                </span>

                                <span v-if="row.item.status === 'OKAY'">
                                    <a :href="row.item.content_type==='TEXT'? '/teacher/essays/' + row.item.id + '/correction/new':'/teacher/essays/' + row.item.id + '/correction'" class="text-success" :disabled="loading" target="_blank" v-b-tooltip.hover title="Acessar correção">
                                        <svg  height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 15l3-3m0 0l-3-3m3 3h-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>

                                    </a>
                                </span>
                            </div>
                        </div>
                    </template>

                </b-table>
            </b-skeleton-wrapper>
            </b-card>

            <!-- Paginate -->
            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <!-- Results -->
            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>
        </div>

        <!-- Show -->
        <show :modes="modes" :can-destroy-correction="canDestroyCorrection"></show>

        <!-- Edit Teacher -->
        <b-modal
            id="editTeacher"
            title="Editar Corretor"
            centered
            hide-footer
        >
            <b-overlay :show="loadingTeacher" rounded="sm">

                <!-- Field -->
                <b-form-group
                    label="Corretor da Redação">

                    <!-- Input -->
                    <multiselect
                        v-model="teacher"
                        :options="teachers"
                        :loading="loadingTeacher"
                        track-by="id"
                        label="name"
                        placeholder=""
                        @select="(value) => formTeacher.teacher_id = value.id"
                        @remove="() => formTeacher.teacher_id = null"
                        tag-placeholder="Pesquisar o Corretor"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há corretores disponíveis para exibir :(
                            </span>

                    </multiselect>

                </b-form-group>

                <b-form-group>

                    <b-button type="button" variant="primary" @click="updateTeacher" :disabled="loadingTeacher">
                        Editar Corretor
                    </b-button>

                </b-form-group>
            </b-overlay>
        </b-modal>

        <!-- Edit Teacher Batch -->
        <b-modal
            id="editTeacherBatch"
            title="Editar Corretor"
            centered
            hide-footer
        >
            <b-overlay :show="loadingTeacher" rounded="sm">

                <div class="alert alert-info d-flex justify-content-between align-items-center">

                    <div>
                        Você está selecionando <b>{{ selected.length }}</b> redações.
                    </div>

                </div>

                <!-- Field -->
                <b-form-group
                    label="Corretor da Redação">

                    <!-- Input -->
                    <multiselect
                        v-model="teacher"
                        :options="teachers"
                        :loading="loadingTeacher"
                        track-by="id"
                        label="name"
                        placeholder=""
                        @select="(value) => formTeacherBatch.teacher_id = value.id"
                        @remove="() => formTeacherBatch.teacher_id = null"
                        tag-placeholder="Pesquisar o Corretor"
                        selectLabel="Selecionar"
                        deselectLabel="Desmarcar"
                        selectedLabel="Selecionado">

                            <span slot="noResult">
                                Ops! Nenhum resultado encontrado na pesquisa :(
                            </span>

                            <span slot="noOptions">
                                Não há corretores disponíveis para exibir :(
                            </span>

                    </multiselect>

                </b-form-group>

                <b-form-group>

                    <b-button type="button" variant="primary" @click="updateTeacherBatch" :disabled="loadingTeacher">
                        Editar Corretor
                    </b-button>

                </b-form-group>
            </b-overlay>
        </b-modal>

        <update-theme-or-mode-modal :modes="modesOnlyActives" :themes="themes" @updated="load" />

        <review-teacher-modal :teachers="teachers" @created="reviewTeacherCreated" ></review-teacher-modal>

        <review-modal :edit="false"></review-modal>

        <!-- Preview -->
        <preview></preview>
    </div>
</template>

<script>
import Show from './Show'
import Preview from './Preview';
import LastEssays from '../LastEssaysNew'
import DateInput from "../DateInput";
import UpdateThemeOrModeModal from './UpdateThemeOrModeModal.vue';
import ReviewTeacherModal from './ReviewTeacherModal.vue';
import ReviewModal from './ReviewModal.vue';

export default {
    components: {
        Show,
        Preview,
        LastEssays,
        DateInput,
        UpdateThemeOrModeModal,
        ReviewTeacherModal,
        ReviewModal,
        
    },
    props: ['endpointIndex', 'endpointCreate', 'modes', 'query', 'canChooseCorrection', 'canFilterCorrection', 'canDestroyCorrection', 'teachers', 'showThemeOfEssay', 'modesOnlyActives', 'revisorTeacher'],
    data() {
        return {
            loading: false,
            loadingGroup: false,
            loadingStudent: false,
            loadingTask: false,
            loadingTeacher: false,
            loadingTheme: false,
            table: [],
            perPage: 15,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: true,
            typeOfDataFilter: 'send',
            fields: [
                { key: 'selected' },
                { key: 'student.name', label: 'Aluno'},
                { key: 'group.name', label: 'Turma' },
                { key: 'teacher.name', label: 'Corretor' },
                { key: 'mode', label: 'Modo'},
                { key: 'status', label: 'Status Correção' },
                { key: 'note', label: 'Nota Final', sortable: true },
                { key: 'created_at', label: 'Enviada', sortable: true },
                { key: 'finished_correction', label: 'Corrigida', sortable: true },
                { key: 'actions', label: '' }
            ],
            filter: {
                group_id: null,
                student_id: null,
                mode_id: null,
                task_id: null,
                status: null,
                teacher_id: null,
                created_at_from: null,
                created_at_to: null,
                finished_correction_from: null,
                finished_correction_to: null,
                theme_id: null,
            },
            lastResultsCount: 5,
            teacher: null,
            teacher2: null,
            essayId: null,
            formTeacher: {
                essay_id: null,
                teacher_id: null,
            },
            formTeacherBatch: {
                teacher_id: null
            },
            theme: null,
            themes: [],
            group: null,
            groups: [],
            student: null,
            students: [],
            task: null,
            tasks: [],
            mode: null,
            status: null,
            statusOptions: [
                {
                    id: 'WAIT',
                    name: 'Somente Aguardando Correção'
                },
                {
                    id: 'IN_PROGRESS',
                    name: 'Somente Correção em Andamento'
                },
                {
                    id: 'BLOCK',
                    name: 'Somente Aguardando Aluno Devolver'
                },
                {
                    id: 'LATE',
                    name: 'Somente Correções Atrasadas'
                },
                {
                    id: 'OKAY',
                    name: 'Somente Corrigidas'
                },
            ],
            selected: [],

            essaysWait: null,
            essaysOkay: null,
            essaysInProgress: null,
        }
    },
    computed: {
        teachersWithNull() {
            let teachers = _.clone(this.teachers);

            teachers.unshift({
                id: 0,
                name: 'Aguardando Corretor ...'
            })

            return teachers;
        }
    },
    watch: {
        'filter.group_id'() {
            this.hideDropdown()
        },
        'filter.student_id'() {
            this.hideDropdown()
        },
        'filter.task_id'() {
            this.hideDropdown()
        },
        'filter.mode_id'() {
            this.hideDropdown()
        },
        'filter.teacher_id'() {
            this.hideDropdown()
        },
        'filter.status'() {
            this.hideDropdown()
        },
        'filter.theme_id'() {
            this.hideDropdown()
        },
        typeOfDataFilter(value){
            if(value === 'correction' && (this.filter.created_at_from || this.filter.created_at_to)){
                this.clearCreateAt();
            }

            if(value === 'send' && (this.filter.finished_correction_from || this.filter.finished_correction_to)){
                this.clearFinishedCorrection();
            }
        },  
    },
    created() {

        // Check if Need Col Theme
        if (this.showThemeOfEssay) {
            this.fields.splice(4, 0, {
                key: 'theme', label: 'Tema', sortable: false
            })

            this.fields.join();
        }

        // Load
        this.load()

        // Load Groups
        this.searchGroup(null)

        // Load Students
        this.searchStudent(null, true)

        // Load Tasks
        this.searchTask(null)

        this.searchTheme(null)
    },
    methods: {
        load() {
            this.loading = true;
            axios.get(this.endpointIndex, {
                params: {
                    group_id: this.filter.group_id,
                    student_id: this.filter.student_id,
                    mode_id: this.filter.mode_id,
                    task_id: this.filter.task_id,
                    status: this.filter.status,
                    teacher_id: this.filter.teacher_id,
                    created_at_from: this.filter.created_at_from,
                    created_at_to: this.filter.created_at_to,
                    finished_correction_from: this.filter.finished_correction_from,
                    finished_correction_to: this.filter.finished_correction_to,
                    theme_id: this.filter.theme_id,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.essays.data
                    this.currentPage = response.essays.current_page
                    this.perPage = response.essays.per_page
                    this.total = response.essays.total

                    this.lastResultsCount = response.essays.data.length

                    this.essaysWait = response.essays_wait
                    this.essaysOkay = response.essays_okay
                    this.essaysInProgress = response.essays_in_progress
                })
                .finally(() => this.loading = false)
        },
        reviewTeacherCreated(){
            window.location.reload();
        },

        hideDropdown(){
            $('#filter-drop').dropdown('hide')
        },
        async clearFilters(){
            this.filter.group_id = await null
            this.filter.mode_id = await null
            this.filter.status = await null
            this.filter.task_id = await null
            this.filter.teacher_id = await null
            this.filter.student_id = await null
            this.filter.theme_id = await null

            this.student = await null
            this.teacher2 = await null
            this.group = await null
            this.task = await null
            this.status = await null
            this.mode = await null
            this.theme = await null

            await this.load()
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.selected = [];
            await this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            await this.load()
        },

        async changeCreateAt(dateFilters) {
            this.filter.created_at_from = await dateFilters.startDate;
            this.filter.created_at_to = await dateFilters.endDate;
            this.load()
        },

        async changeFinishedCorrection(dateFilters) {
            this.filter.finished_correction_from = await dateFilters.startDate;
            this.filter.finished_correction_to = await dateFilters.endDate;
            this.load()
        },

        async clearCreateAt() {
            this.filter.created_at_from = null;
            this.filter.created_at_to = null;
            this.load()
        },

        async clearFinishedCorrection() {
            this.filter.finished_correction_from = null;
            this.filter.finished_correction_to = null;
            this.load()
        },

        searchGroup(text) {
            this.loadingGroup = true;
            axios.get('/teacher/groups/search', {
                params: {
                    name: text
                }
            })
                .then((result) => {
                    this.groups = result.data.data.groups;
                })
                .finally(() => this.loadingGroup = false)
        },

        searchTheme(text){
            this.loadingTheme = true;
            axios.get('/teacher/themes/search', {
                params: {
                    theme_id: this.theme_id,
                    title: text,
                }
            })
            .then((result) => {
                    this.themes = result.data.data.themes;
                })
                .finally(() => this.loadingTheme = false)
        },

        searchStudent(text, searchViaQuery = false) {
            this.loadingStudent = true;
            axios.get('/teacher/students/search', {
                params: {
                    group_id: this.filter.group_id,
                    name: text
                }
            })
                .then(async (result) => {
                    this.students = await result.data.data.students;

                    // Check Params via Query
                    if (searchViaQuery) {
                        if (this.query.studentId) {
                            this.students.forEach((student) => {
                                if (student.id == this.query.studentId) {
                                    this.student = student;
                                    this.filter.student_id = this.query.studentId;
                                    // Load
                                    this.load()
                                }
                            })
                        }
                    }
                })
                .finally(() => this.loadingStudent = false)
        },

        searchTask(text) {
            this.loadingTask = true;
            axios.get('/teacher/tasks/search', {
                params: {
                    group_id: this.filter.group_id,
                    name: text
                }
            })
                .then(async (result) => {
                    this.tasks = await result.data.data.tasks;
                })
                .finally(() => this.loadingTask = false)
        },
        async selectTheme(value){
            this.filter.theme_id = await value.id

            await this.load();
        },
        async removeTheme() {
            this.filter.theme_id = await null
            this.theme = await null
            // Load
            await this.load()
        },

        async selectGroup(value) {
            this.filter.group_id = await value.id;
            this.filter.student_id = await null
            this.filter.task_id = await null
            this.student = await null
            this.task = await null

            // Load Students
            await this.searchStudent(null)

            // Load Tasks
            await this.searchTask(null)

            // Load
            await this.load()


        },

        async removeGroup() {
            this.filter.group_id = await null
            this.filter.student_id = await null
            this.filter.task_id = await null
            this.group = await null
            this.student = await null
            this.task = await null

            // Load Students
            await this.searchStudent(null)

            // Load Tasks
            await this.searchTask(null)

            // Load
            await this.load()

        },

        async selectStudent(value) {
            this.filter.student_id = await value.id;

            // Load
            await this.load()
        },

        async removeStudent() {
            this.filter.student_id = await null
            this.student = await null
            // Load
            await this.load()
        },

        async selectTask(value) {
            this.filter.task_id = await value.id;

            // Load
            await this.load()
        },

        async removeTask() {
            this.filter.task_id = await null
            this.task = await null
            // Load
            await this.load()
        },

        async selectTeacher(value) {

            this.filter.teacher_id = await value.id;
            // Load
            await this.load()
        },

        async removeTeacher() {
            this.filter.teacher_id = await null
            this.teacher2 = await null
            // Load
            await this.load()
        },

        async selectStatus(value) {
            this.filter.status = await value.id;

            // Load
            await this.load()
        },

        async removeStatus() {
            this.filter.status = await null
            this.status = await null
            // Load
            await this.load()
        },

        async selectMode(value) {
            this.filter.mode_id = await value.id;

            // Load
            await this.load()
        },

        async removeMode() {
            this.filter.mode_id = await null
            this.mode = await null
            // Load
            await this.load()
        },

        showDetails(essay) {
            this.$root.$emit('essaysShowDetail', essay);
        },

        startCorrectionEssay(id) {
            if (confirm('Tem certeza que deseja iniciar a correção desta redação ?')) {
                this.loading = true;
                axios.put('/teacher/essays/' + id + '/change-status', {
                    status: 'IN_PROGRESS'
                })
                    .then((result) => {
                        window.open('/teacher/essays/' + id + '/correction', '_blank');
                    })
                    .finally(() => this.loading = false)
            }
        },

        showTeacherModal(essay) {

            this.formTeacher.essay_id = essay.id;
            this.formTeacher.teacher_id = essay.teacher_id;

            this.teacher = essay.teacher

            this.$bvModal.show('editTeacher')

        },

        updateTeacher() {
            this.loadingTeacher = true;
            axios.put('/teacher/essays/update-teacher', this.formTeacher)
                .then((result) => {

                    // Load
                    this.load();

                    // Message
                    this.$toast.success('Corretor foi selecionado com sucesso !');

                    // Close Modal
                    this.$bvModal.hide('editTeacher')

                })
                .finally(() => this.loadingTeacher = false)
        },

        showImage(essay) {
            this.$root.$emit('showPreviewEssay', essay)
        },

        onRowSelected(items) {
            this.selected = items;
        },

        inputSelect(event, key) {
            if (event) {
                this.$refs.selectableTable.selectRow(key)
            } else {
                this.$refs.selectableTable.unselectRow(key)
            }
        },

        inputSelectAll(event) {
            if (event) {
                this.$refs.selectableTable.selectAllRows()
            } else {
                this.$refs.selectableTable.clearSelected();
            }
        },

        selectTeacherBatch() {
            this.formTeacherBatch.teacher_id = null;
            this.$bvModal.show('editTeacherBatch')
        },

        updateTeacherBatch() {
            this.loadingTeacher = true;
            axios.put('/teacher/essays/update-teacher-batch', {
                ...this.formTeacherBatch,
                selected: this.selected.map((sel) => sel.id)
            })
                .then((result) => {

                    // Load
                    this.load();

                    this.selected = []

                    // Message
                    this.$toast.success('Corretor foi alterados com sucesso !');

                    // Close Modal
                    this.$bvModal.hide('editTeacherBatch')

                })
                .finally(() => this.loadingTeacher = false)
        },

        showUpdateThemeOrMode(essay) {
            this.$root.$emit('updateThemeOrMode', essay);
        },

        showReviewTeacher(essay) {
            this.$root.$emit('ReviewTeacher', essay);
        },

        showReview(review) {
            this.$root.$emit('ReviewEssay', review);
        },

    }
}
</script>

<style scoped>

</style>
